import { partsFormAsyncSetActions } from 'shared/actions/partsForm';
import API from 'shared/constants/api';
import queryString from 'query-string';

export const company = data => {
  const { store } = data;
  const {
    searchForm: {
      selected: { company: companys },
    },
  } = store.getState();
  if (!companys) {
    return store.dispatch(partsFormAsyncSetActions.company(data));
  }
  return false;
};

export const fetchedLinks = ({ fetch }, g, location) =>
  fetch(
    `${API.FIRMS.TAGS_COUNT}?${queryString.stringify({
      ...(location && location.id ? { location: location.id } : {}),
      ...g,
    })}`,
  ).then(r => r.json());



// WEBPACK FOOTER //
// ./src/shared/modules/firms.js